import { render } from "./TestSelectMcView.vue?vue&type=template&id=4ed2b1fb&scoped=true"
import script from "./TestSelectMcView.vue?vue&type=script&lang=js"
export * from "./TestSelectMcView.vue?vue&type=script&lang=js"

import "./TestSelectMcView.vue?vue&type=style&index=0&id=4ed2b1fb&scoped=true&lang=css"

import exportComponent from "/Users/fredde/programvara/boove.se/w3.boove.se/w3.boove.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ed2b1fb"]])

export default __exports__